import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import ResultPage from "../../components/Track/Result";
import { authsignature, storage } from "../../libs";
import Loading from "../../components/Main/Loading";

function Result() {
  const search = useLocation();
  const history = useHistory();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (search) {
      const urlParams = Object.fromEntries([...new URLSearchParams(search)]);
      getUrl(urlParams);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const getUrl = async (url) => {
    if (url) {
      const encrypted = url.pathname.replace("/result/", "");
      const auth = await storage();
      setLoading(true);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/transaction/verification`,
          { encrypt: encrypted.toString() },
          {
            headers: await authsignature(auth.token, {
              encrypt: encrypted.toString(),
            }),
          }
        );

        if (Number(response.data.code) === 200) {
          setData(response.data.data);
          setLoading(false);
        } else {
          setLoading(false);
          history.push("/");
        }
      } catch (e) {
        setLoading(false);
        history.push("/");
      }
    } else {
      history.push("/");
    }
  };

  return loading ? <Loading /> : <ResultPage props={{ data }} />;
}

export default Result;
